import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Alert,
    Box,
    Divider,
    Grid,
    Tooltip,
    Typography
} from '@mui/material'
import { GridArrowDownwardIcon } from '@mui/x-data-grid'
import { t } from 'i18next'
import React from 'react'
import { ThrZones } from '../../shared/types/exam.type'
import HrActivityZone from './HrActivityZone'
import DonutActivityZone from './DonutActivityZone'
import { Info } from '@mui/icons-material'
import { routes } from '../../pages/routes'
import { Ttraining } from '../../shared/types/training.type'
import PoloActivityZone from './PoloActivityZone'
import { TUser } from '../../shared/types/user.type'
import { useAuth } from "../../hooks/useAuth";
import CellularEnergy from './CellularEnergy'

type gaitProps = {
    data?: ThrZones,
    maxHr?: number,
    maxHrRest?: number,
    horseId?: number,
    printable?: boolean,
    totalDistance?: string,
    totalTime?: string,
}

function GaitAndHrZone({ maxHrRest, data, maxHr, horseId, printable = false, totalDistance, totalTime }: gaitProps) {

    const { isUserTypePolo } = useAuth()

    return (
        <Accordion defaultExpanded>
            <AccordionSummary
                expandIcon={<GridArrowDownwardIcon />}
            >
                <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                    <Grid container spacing={4}>
                        <Grid item md={4} sm={12} xs={12}>
                            <Typography
                                variant='subtitle2'>{t(isUserTypePolo ? 'averagesGait:title' : 'averagesAndHrZones:title')}</Typography>
                        </Grid>


                    </Grid>
                </Box>
            </AccordionSummary>
            <AccordionDetails className="slider-container">

                <Grid container spacing={4}>
                    {/* DONUT Section */}

                    <Grid item md={isUserTypePolo ? 12 : 6} sm={12} xs={12} alignItems={'center'}>
                        <DonutActivityZone
                            printable={printable}
                            data={data?.gait_averages}
                            totalDistance={totalDistance}
                            totalTime={totalTime}></DonutActivityZone>
                    </Grid>

                    {/* Title display on responsive */}
                    {
                        isUserTypePolo &&
                        <Grid sx={{ display: { sm: 'initial', md: 'initial', xs: 'none' } }} item md={12} sm={12} xs={12}>

                            <Box>
                                <Typography variant='subtitle2'>{t('workZone:title')}</Typography>
                                <Divider sx={{ mt: 1 }}></Divider>
                            </Box>


                        </Grid>
                    }


                    {/* Title display on responsive */}
                    <Grid sx={{ display: { sm: 'initial', md: 'none', xs: 'none' } }} item md={6} sm={12} xs={12}>
                        {
                            isUserTypePolo &&
                            <Box sx={{ display: { xs: 'initial', md: 'none' } }}>
                                <Typography  variant='subtitle2'>{t('averagesAndHrZones:title')}</Typography>
                                <Divider sx={{ mt: 1 }}></Divider>
                            </Box>
                        }

                    </Grid>





                    {/* Hr Activity Zone */}
                    <Grid item md={isUserTypePolo ? 5 : 6} sm={12} xs={12}>


                        {
                            isUserTypePolo &&
                            <Box sx={{ display: { xs: 'initial', md: 'none', sm: 'none' } }}>
                                <Typography variant='subtitle2'>{t('averagesAndHrZones:title')}</Typography>
                                <Divider sx={{ mt: 1 }}></Divider>
                            </Box>
                        }
                        {
                            isUserTypePolo && <Typography fontSize={13} mt={{ md: 0, xs: isUserTypePolo ? 2 : 0 }}
                                mb={4}>{t('averagesGait:accordingToHr')}</Typography>
                        }
                        <HrActivityZone
                            printable={printable}
                            params={{
                                includeInactivity: data?.hr_zones_with_inactivity_and_walk,
                                excludeInactivity: data?.hr_zones_without_inactivity_and_walk
                            }}></HrActivityZone>
                        <Alert icon={
                            <Tooltip title={<div
                                dangerouslySetInnerHTML={{ __html: t('parameters:tooltipInfoTrainingPageMaxHeartRate', { path: routes.DASHBOARD_ROUTES.HORSE_VIEW.replace(':id', String(horseId)) }) }}></div>}
                                arrow>
                                <Info sx={{ width: 20, height: 20 }}></Info>
                            </Tooltip>
                        } sx={{ mt: 2 }} variant='outlined' severity='info'>
                            {t(isUserTypePolo ? 'intervals:maxHeartRate' : 'parameters:individualMaxHeartRate')} : {maxHr ?? ' - '} {t('units:bpm')}
                        </Alert>
                        {
                            isUserTypePolo && <Alert icon={
                                <Tooltip title={<div
                                    dangerouslySetInnerHTML={{ __html: t('parameters:tooltipInfoTrainingPageHeartRateAtRest') }}></div>}
                                    arrow>
                                    <Info sx={{ width: 20, height: 20 }}></Info>
                                </Tooltip>} sx={{ mt: 2 }} variant='outlined' severity='info'>
                                {t('parameters:individualMaxHeartRateRestPolo')} : {maxHrRest ?? ' - '} {t('units:bpm')}
                            </Alert>
                        }
                    </Grid>

                    {/* Celular Zone */}
                    {
                        isUserTypePolo && <Grid item md={2} sm={12} xs={12}>
                             <Typography fontSize={13} mb={4} sx={{ placeSelf: 'center' }}
                                mt={{ xs: 0, sm: 2, md: 0 }}>{t('celular:title')}</Typography>
                            <CellularEnergy />
                        </Grid>
                    }


                    {/* Last Speed Section */}
                    {
                        isUserTypePolo && <Grid item md={isUserTypePolo ? 5 : 6} sm={12} xs={12}>
                            <Typography fontSize={13} mb={4}
                                mt={{ xs: 0, sm: 2, md: 0 }}>{t('averagesGait:accordingToSpeed')}</Typography>

                            <PoloActivityZone
                                printable={printable}
                                params={{
                                    includeInactivity: data?.polo_speed_zones,
                                    excludeInactivity: data?.polo_speed_zones_without_low_speeds
                                }}></PoloActivityZone>

                        </Grid>
                    }

                </Grid>


            </AccordionDetails>
        </Accordion>
    )
}

export default GaitAndHrZone